import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { ShortListCreateContainer } from './styled'
import { shortListPath } from 'routes'
import ShortListPart from '../Forms/ShortListPart'
import { createShortList } from 'ducks/shortList'
import { validateGeneralForm, validateVendorForm } from '../attributeData'

const ShortListCreate = (props) => {
  const { valueForm, change, createShortList, history, isDetail = false} = props
  const [isSubmit, setIsSubmit] = useState(false)

  const onSubmitCreateForm = (values) => {
    var errors = {}
    errors = validateGeneralForm(values, errors)

    // if (isSubmit) {
    //   var vendors = values.vendors || []
    //   errors = validateVendorForm(vendors, errors)
    // }

    if (Object.keys(errors).length) {
      scrollToFirstValidateFailElement(errors)
      throw new SubmissionError(errors)
    } else {
      createShortList(values, isSubmit, history)
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle='Short List - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'SL', content: 'Short List', link: true, onClick: () => props.history.push(shortListPath) },
              { key: 'SLCreate', content: 'Create', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <ShortListCreateContainer>
            <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
              <ShortListPart valueForm={valueForm} change={change} isDetail={isDetail} />
              <div className='btnContainer'>
                <div className='left'></div>
                <div className='right'>
                  <Button
                    type='submit'
                    content='Save'
                    icon='save'
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={() => setIsSubmit(false)}
                  />
                  <Button
                    type='submit'
                    content='Save & Submit'
                    color='blue'
                    icon='save'
                    labelPosition='right'
                    style={{ marginRight: '5px' }}
                    onClick={() => setIsSubmit(true)}
                  />
                </div>
              </div>
            </form>
          </ShortListCreateContainer>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  const vf = getFormValues('formShortList')(state) || {}

  return ({
    valueForm: vf,
    initialValues: {
      ...vf,
      createdBy: vf.createdBy ? vf.createdBy : username,
      documentDate: vf.documentDate ? vf.documentDate : new Date(),
    }
  })
}

const mapDispatchToProps = {
  createShortList
}

const ShortListCreateForm = reduxForm({
  form: 'formShortList',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement
})(ShortListCreate)

export default connect(mapStateToProps, mapDispatchToProps)(ShortListCreateForm)